module.exports = __webpack_public_path__ + "img/honourHover.e3d46719.png";